import NetworkContent from '@/helpers/networking/NetworkContent';

const publicVapidKey = import.meta.env.VITE_PUBLICVAPIDKEY;

// Copied from the web-push documentation
const urlBase64ToUint8Array = (base64String) => {
  // eslint-disable-next-line no-mixed-operators
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};
async function checkServiceAvailable() {
  return ('serviceWorker' in navigator);
}

async function checkSubscription() {
  try {
    // Check if VAPID key is configured
    if (!publicVapidKey) {
      console.error('[Push] VITE_PUBLICVAPIDKEY is not set in environment variables');
      return null;
    }

    const serviceWorker = await navigator.serviceWorker.register('../push_serviceworker.js', {
      scope: '../',
    });

    await serviceWorker.update();

    let registrations = await navigator.serviceWorker.getRegistrations();

    if (registrations.length === 0) {
      await navigator.serviceWorker.register('../sw.js', {
        scope: '../',
      });
      registrations = await navigator.serviceWorker.getRegistrations();
    }

    if (registrations.length === 0) {
      console.error('[Push] No service worker registrations found');
      return null;
    }

    // check old subscription
    let subscription = await registrations[0].pushManager.getSubscription();

    // if subscription is not there
    // make new subscription
    if (subscription == null) {
      try {
        subscription = await registrations[0].pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
        });
        await NetworkContent.subscribeToPush({ subscription });
        return subscription;
      } catch (error) {
        console.error('[Push] Error creating subscription:', error);
        if (error instanceof Error && error.message.includes('permission')) {
          console.warn('[Push] User denied push notification permission');
        }
        return null;
      }
    }

    // Check if subscription uses the correct VAPID key
    const currentKey = urlBase64ToUint8Array(publicVapidKey).toString();
    const subscriptionKey = new Uint8Array(subscription.options.applicationServerKey).toString();

    if (currentKey !== subscriptionKey) {
      // if subscription is made with old key
      // delete old subscription and make new one
      try {
        await subscription.unsubscribe();
        subscription = await registrations[0].pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
        });
        await NetworkContent.subscribeToPush({ subscription });
        return subscription;
      } catch (error) {
        console.error('[Push] Error updating subscription:', error);
        return null;
      }
    }

    // Subscription exists and is valid - verify it's saved in backend
    try {
      await NetworkContent.subscribeToPush({ subscription });
    } catch (error) {
      // Silently fail - subscription may already exist
    }

    return subscription;
  } catch (error) {
    console.error('[Push] Error in checkSubscription:', error);
    return null;
  }
}

export { checkServiceAvailable, checkSubscription };
